import styled from "@emotion/styled";
import React from "react";

import formatToCurrency from "../utils/format-to-currency";

interface Props {
  storeName?: string;
  amount?: number;
  storeLogo?: string;
}

const Container = styled.div`
  flex: 1 0 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

const StoreName = styled.span`
  font-weight: 600;
  color: #1c1c1c;
`;

const Price = styled.span`
  color: #1c1c1c;
  font-family: "Hiragino Sans";
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
`;

const PriceSuffix = styled.span`
  font-family: "Hiragino Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #1c1c1c;
`;

const StoreImageContainer = styled.div`
  width: 64px;
  height: 64px;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.img`
  width: 32px;
  height: 32px;
`;

const StoreHeader = ({ storeName, amount }: Props) => (
  <Container>
    <div>
      <StoreName>{storeName}</StoreName>
      <br />
      <Price>
        {formatToCurrency(Number.isInteger(amount) ? (amount as number) : 0, true)}
        <PriceSuffix> 円</PriceSuffix>
      </Price>
    </div>
    
    <StoreImageContainer title="Shop logo container">
      <Logo
        src="/assets/google_logo.png"
        alt="Shop logo"
      />
    </StoreImageContainer>
  </Container>
);

export default StoreHeader;
